module.exports = __webpack_public_path__ + "img/back.e66c5aba.svg";